export default class User {
  /**
   * コンストラクタ
   * @param {Object} user ユーザー
   */
  constructor(user = null) {
    this._id = this.paramFromObject(user, 'id');
    this._email = this.paramFromObject(user, 'email');
    this._full_name = this.paramFromObject(user, 'full_name');
    this._password = this.paramFromObject(user, 'password');
    this._password_confirmation = this.paramFromObject(user, 'password_confirmation');
    this.is_admin = this.paramFromObject(user, 'is_admin');
  }

  paramFromObject(user, param, initValue = null) {
    return user == null || user[param] == null ? initValue : user[param];
  }

  formatParams() {
    let formData = new FormData();
    const appendFormData = function (name, value) {
      if (value == null) value = '';
      formData.append(`user[${name}]`, value);
    };
    appendFormData('full_name', this.full_name);
    appendFormData('email', this.email);
    if (!this.id) appendFormData('password', this.password);
    if (!this.id) appendFormData('password_confirmation', this.password_confirmation);

    return formData;
  }

  /**
   * ObjectからUserクラスへ変換する
   * @param {Object} obj ユーザーオブジェクト
   * @returns {User} ユーザー
   */
  static fromObject(obj = null) {
    return new User(obj);
  }

  /**
   * ID
   * @returns {number}
   */
  get id() {
    return this._id;
  }

  set id(value) {
    this._id = value;
  }

  /**
   * 名前
   * @returns {string}
   */
  get full_name() {
    return this._full_name;
  }

  set full_name(value) {
    this._full_name = value;
  }

  /**
   * メールアドレス
   * @returns {string}
   */
  get email() {
    return this._email;
  }

  set email(value) {
    this._email = value;
  }

  /**
   * パスワード
   * @returns {string}
   */
  get password() {
    return this._password;
  }

  set password(value) {
    this._password = value;
  }

  /**
   * パスワード（確認）
   * @returns {string}
   */
  get password_confirmation() {
    return this._password_confirmation;
  }

  set password_confirmation(value) {
    this._password_confirmation = value;
  }
}
